(() => {
  if (window.__baysExperience) return;
  window.__baysExperience = true;
  const init = () => {
    const elements = [...document.querySelectorAll('[data-bx-reveal]')];
    const revealAll = () => elements.forEach(element => {
      element.classList.remove('bx-reveal-pending');
      element.classList.add('bx-seen');
    });
    if (matchMedia('(prefers-reduced-motion: reduce)').matches ||
        document.documentElement.classList.contains('is-webkit') ||
        typeof IntersectionObserver !== 'function') {
      revealAll();
      return;
    }
    let observer;
    try {
      observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('bx-seen');
          entry.target.classList.remove('bx-reveal-pending');
          observer.unobserve(entry.target);
        }
      }), { threshold: .1 });
      elements.forEach(element => {
        element.classList.add('bx-reveal-pending');
        observer.observe(element);
      });
    } catch {
      observer?.disconnect();
      revealAll();
    }
    window.addEventListener('pageshow', event => {
      if (event.persisted) {
        observer?.disconnect();
        revealAll();
      }
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();

/* A wishlist remains usable when private/in-app browser storage is unavailable. */
(() => {
  const key = 'bays:wishlist';
  let items = [];
  let storageAvailable = true;
  const read = () => {
    try {
      if (storageAvailable) {
        const stored = JSON.parse(localStorage.getItem(key) || '[]');
        items = Array.isArray(stored) ? stored.filter(value => typeof value === 'string') : [];
      }
    } catch {
      storageAvailable = false;
    }
    return items;
  };
  const bind = () => document.querySelectorAll('a[href="#bays-wishlist"]').forEach(button => {
    if (button.dataset.wishlistReady) return;
    button.dataset.wishlistReady = '1';
    const item = location.pathname;
    const paint = () => {
      const saved = read().includes(item);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.textContent = saved ? 'SAVED TO WISHLIST' : 'SAVE TO WISHLIST';
    };
    paint();
    button.addEventListener('click', event => {
      event.preventDefault();
      const current = read();
      items = current.includes(item) ? current.filter(value => value !== item) : [...current, item];
      try {
        if (storageAvailable) localStorage.setItem(key, JSON.stringify(items));
      } catch {
        storageAvailable = false;
      }
      paint();
    });
  });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', bind) : bind();
  document.addEventListener('shopify:section:load', bind);
})();
